import { type QuickEntryItem, type QuickEntryItemPC } from "../types/models";
import { getFirstValidDate } from "~/common/utils/dateUtils";

import { getInitialPriceReference } from "~/features/addToCart/redux/addToCart/getInitialPriceReference";
import type { PriceReferenceSelection } from "~/domains/priceReference/types";

export function getEmptyRow(selection: PriceReferenceSelection | undefined): QuickEntryItem {
  return {
    quantity: 1,
    product: undefined,
    productId: "",
    previousProductId: "",
    packCode: "",
    requestedDeliveryDate: getFirstValidDate(),
    isCommentVisible: false,
    comment: "",
    priceReference: getInitialPriceReference(selection),
  };
}
export const EMPTY_ROW_PC: QuickEntryItemPC = {
  product: undefined,
  productId: "",
  previousProductId: "",
};

export const INVALID_ENTRY_ID = -1;
